module.exports = __webpack_public_path__ + "img/1744683245455-image.jpg.ee4c6f45.webp";